import AuthFormContainer from './AuthFormContainer';

export default AuthFormContainer;
